import axios from "axios";
import { backendUrl } from "../../config/config";

const url = backendUrl + "/doubt";

const createDoubt = async (data) => {
  try {
    const res = await axios.post(`${url}/create`, data);
    return res;
  }
  catch (err) {
    return err.response;
  }
}

const deleteDoubt = async (data) => {
  try {
    const res = await axios.delete(`${url}/delete`, { data });
    return res;
  }
  catch (err) {
    return err.response;
  }
}

const readDoubt = async (doubtId) => {
  try {
    const res = await axios.get(`${url}/read/${doubtId}`);
    return res;
  }
  catch (err) {
    return err.response;
  }
}

const readManyDoubts = async () => {
  try {
    const res = await axios.get(`${url}/read-many`);
    return res;
  }
  catch (err) {
    return err.response;
  }
}

const updateDoubt = async (data) => {
  try {
    const res = await axios.put(`${url}/update`, data);
    return res;
  }
  catch (err) {
    return err.response;
  }
}

export {
  createDoubt,
  deleteDoubt,
  readDoubt,
  readManyDoubts,
  updateDoubt
}